class ImageGalleryParallax {
	constructor(block) {
	  this.block = block;
	  this.img = this.block.querySelector('img');
  
	  if (this.img) {
		this.onScroll = this.onScroll.bind(this);
		window.addEventListener('scroll', this.onScroll);
		this.onScroll();
	  }
	}
  
	onScroll() {
	  const rect = this.block.getBoundingClientRect();
	  const containerHeight = this.block.offsetHeight;
	  const imgHeight = this.img.offsetHeight;
  
	  if (imgHeight > containerHeight) {
		let scrollPercent = (window.innerHeight - rect.top) / (window.innerHeight + containerHeight);
		scrollPercent = Math.max(0, Math.min(1, scrollPercent));
		const maxOffset = imgHeight - containerHeight;
		const offset = -maxOffset / 2 + maxOffset * scrollPercent;
		this.img.style.transform = `translate(-50%, calc(-50% + ${offset}px))`;
		}
	}
  }
  
  
  export default ImageGalleryParallax;
  